import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { environment } from '../environments/environment';
import Amplify from 'aws-amplify';
import { AuthenticationService } from './core/services/authentication.service';
import { DateUtils } from '@aws-amplify/core';
import { Constants } from './shared/constants';
import { SessionManagementService } from './core/services/session-management.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'Crisis Alert Review System';

  hasIdpCode: boolean;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private sessionManagementService: SessionManagementService) {
    router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        console.log("extendSession is called with routing");
        this.sessionManagementService.extendSession();
      });
  }

  ngOnInit() {
    this.preConfigProcess();
    this.configureAmplify();
    this.postConfigProcess();
  }

  preConfigProcess() {
    const urlParams = new URLSearchParams(window.location.search);
    console.log('preConfigProcess: code ', urlParams.has('code'));
    this.hasIdpCode = urlParams.has('code');
  }

  configureAmplify(): void {
    DateUtils.setClockOffset(0);
    const cognitoOpts = environment.internal ?
      environment.int.cognito : environment.ext.cognito;
    const amplifyConfig = Amplify.configure({
      Auth: cognitoOpts,
      API: environment.api,
      Storage: environment.s3
    });
    console.log('Amplify Configured.');
  }

  postConfigProcess() {

    this.authenticationService.isAuthenticated().subscribe(data => {
      if (data) {
        console.log('User is already authenticated.');
        if (sessionStorage.getItem('currentUser') != null) {
          this.router.navigate(['/cases']);
        } else {
          // TODO Current user is not found. The user might not have logged in properly or
          // his browser might havebeen corrupted. Close the borwser and re login.
          console.log('Current user is not found. The user might not have logged in properly' +
            'or his browser might havebeen corrupted. Close the borwser and login again.');
          this.authenticationService.logout(Constants.LogoutReason_LOGOUT);
        }
      } else {
        // User is not logged in begin Authentication Process
        if (this.hasIdpCode) {
          console.log('Wait for the AWS Amplify to finish its work for Oauth Flow.');
        } else {
          console.log('FederatedSignIn.....');
          this.authenticationService.login();
        }
      }
    }, error => {
      console.log('Error checking if the user is authenticated', error);
    }
    );
  }

  getAnimationData(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
